/* Today in Motion — today's weather + style tip (sections/today-weather.liquid).
   Forecast: Open-Meteo (free, no key, no ads). Cached 30 min in sessionStorage. Fails silently (card stays hidden). */
(() => {
  if (customElements.get('today-weather')) return;

  const ICONS = {
    clear: '<circle cx="12" cy="12" r="4.2"/><path d="M12 2.5v2.2M12 19.3v2.2M4.6 4.6l1.6 1.6M17.8 17.8l1.6 1.6M2.5 12h2.2M19.3 12h2.2M4.6 19.4l1.6-1.6M17.8 6.2l1.6-1.6"/>',
    partly: '<path d="M9 3.5v1.6M3.8 8.7h1.6M5.3 5l1.1 1.1M12.7 5l-1.1 1.1"/><path d="M6.6 10.4a3.4 3.4 0 0 1 6-1.9"/><path d="M8 19.5h9.2a3.6 3.6 0 0 0 .3-7.2 5 5 0 0 0-9.6 1.2A3 3 0 0 0 8 19.5z"/>',
    cloudy: '<path d="M6.5 18.5h11a4 4 0 0 0 .4-8 5.5 5.5 0 0 0-10.6 1.4A3.3 3.3 0 0 0 6.5 18.5z"/>',
    fog: '<path d="M6.5 13.5h11a4 4 0 0 0 .4-8 5.5 5.5 0 0 0-10.6 1.4"/><path d="M4 17h16M6 20.5h12"/>',
    drizzle: '<path d="M6.5 15h11a4 4 0 0 0 .4-8 5.5 5.5 0 0 0-10.6 1.4A3.3 3.3 0 0 0 6.5 15z"/><path d="M9 18l-.5 1.5M13 18l-.5 1.5M17 18l-.5 1.5"/>',
    rain: '<path d="M6.5 14h11a4 4 0 0 0 .4-8 5.5 5.5 0 0 0-10.6 1.4A3.3 3.3 0 0 0 6.5 14z"/><path d="M8.5 17l-1.2 3.5M12.5 17l-1.2 3.5M16.5 17l-1.2 3.5"/>',
    storm: '<path d="M6.5 14h11a4 4 0 0 0 .4-8 5.5 5.5 0 0 0-10.6 1.4A3.3 3.3 0 0 0 6.5 14z"/><path d="M12.5 15.5l-2 3.5h3l-2 3.5"/>',
    snow: '<path d="M6.5 14h11a4 4 0 0 0 .4-8 5.5 5.5 0 0 0-10.6 1.4A3.3 3.3 0 0 0 6.5 14z"/><path d="M9 18.5h.01M12 20.5h.01M15 18.5h.01"/>',
  };

  // WMO weather codes → our condition keys
  const condOf = (c) => (c === 0 ? 'clear' : c <= 2 ? 'partly' : c === 3 ? 'cloudy' : c <= 48 ? 'fog'
    : c <= 57 ? 'drizzle' : c <= 67 ? 'rain' : c <= 77 ? 'snow' : c <= 82 ? 'rain' : c <= 86 ? 'snow' : 'storm');

  const tipOf = (cond, high, rainChance) => {
    if (cond === 'rain' || cond === 'storm' || cond === 'drizzle' || rainChance >= 60) return 'rain';
    if (high <= 15) return 'cold';
    if (high <= 20) return 'cool';
    if (high <= 25) return 'mild';
    if (high <= 30) return 'warm';
    return 'hot';
  };

  class TodayWeather extends HTMLElement {
    async connectedCallback() {
      let s;
      try { s = JSON.parse(this.querySelector('[data-wx-strings]').textContent); } catch (e) { return; }
      const { lat, lon, tz } = this.dataset;
      const key = `sim-wx:${lat},${lon}`;
      let data = null;
      try {
        const c = JSON.parse(sessionStorage.getItem(key) || 'null');
        if (c && Date.now() - c.t < 30 * 60 * 1000) data = c.d;
      } catch (e) { /* private mode */ }
      if (!data) {
        const url = `https://api.open-meteo.com/v1/forecast?latitude=${encodeURIComponent(lat)}&longitude=${encodeURIComponent(lon)}`
          + '&current=temperature_2m,weather_code'
          + '&daily=temperature_2m_max,temperature_2m_min,precipitation_probability_max'
          + `&timezone=${encodeURIComponent(tz)}&forecast_days=1`;
        try {
          const ctl = new AbortController();
          const timer = setTimeout(() => ctl.abort(), 6000);
          const r = await fetch(url, { signal: ctl.signal });
          clearTimeout(timer);
          if (!r.ok) return;
          data = await r.json();
          try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), d: data })); } catch (e) { /* ignore */ }
        } catch (e) { return; }
      }
      const cur = data.current || {};
      const day = data.daily || {};
      if (typeof cur.temperature_2m !== 'number') return;
      const high = Math.round(day.temperature_2m_max?.[0] ?? cur.temperature_2m);
      const low = Math.round(day.temperature_2m_min?.[0] ?? cur.temperature_2m);
      const rain = day.precipitation_probability_max?.[0] ?? 0;
      const cond = condOf(cur.weather_code);
      const tip = s.tips[tipOf(cond, high, rain)];

      this.querySelector('[data-wx-icon]').innerHTML =
        `<svg viewBox="0 0 24 24" width="40" height="40" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round">${ICONS[cond]}</svg>`;
      this.querySelector('[data-wx-temp]').textContent = `${Math.round(cur.temperature_2m)}°`;
      this.querySelector('[data-wx-cond]').textContent = s.cond[cond];
      this.querySelector('[data-wx-range]').textContent = `${s.high} ${high}° · ${s.low} ${low}°`;
      this.querySelector('[data-wx-line]').textContent = tip.line;
      const cta = this.querySelector('[data-wx-cta]');
      cta.href = tip.url;
      this.querySelector('[data-wx-cta-label]').textContent = tip.cta;
      this.hidden = false;
      const credit = this.parentElement.querySelector('[data-wx-credit]');
      if (credit) credit.hidden = false;
    }
  }
  customElements.define('today-weather', TodayWeather);
})();
